// export const API_URL = "http://localhost:8090/api/v1"

export const API_URL="https://webbulksms.co.tz/api/v1";


// export const API_URL = "http://155.12.30.77:8085/api/v1";


